// extracted by mini-css-extract-plugin
export default {"photosFooter":"photosFooter___T0qKC","photosFooter_title":"photosFooter_title___Y2CcG"};